import { css } from '@emotion/core';
import { tokens, applyFont } from '@domain-group/fe-brary';
var colors = tokens.colors,
  typography = tokens.typography,
  spacing = tokens.spacing;
export var newDevelopmentCard = /*#__PURE__*/css("position:relative;display:flex;flex-direction:column;border:1px solid ", colors.neutral.trim.default, ";background-color:", colors.neutral.surface.default, ";overflow:hidden;&[data-new-dev-layout='two-column']{flex-direction:row;width:720px;height:320px;}&[data-new-dev-layout='three-column']{flex-direction:row;width:1020px;height:280px;}");
export var badges = {
  name: "1isulpl",
  styles: "position:unset;flex-grow:1;"
};
export var cardBody = {
  name: "1f2y6f0",
  styles: "display:flex;flex-direction:column;width:100%;[data-new-dev-layout='three-column'] &{flex-direction:row;}"
};
export var parentSection = /*#__PURE__*/css("display:flex;flex-direction:column;justify-content:flex-start;gap:", spacing.s, ";padding:", spacing.m, ";overflow:hidden;[data-new-dev-layout='three-column'] &{width:400px;}");
export var childSection = {
  name: "1f05xb2",
  styles: "display:flex;flex-direction:column;[data-new-dev-layout='two-column'] &{justify-content:space-between;flex-grow:1;}[data-new-dev-layout='three-column'] &{justify-content:space-between;flex-grow:1;flex-shrink:0;width:300px;}"
};
export var childrenLinkContainer = {
  name: "13phs75",
  styles: "text-decoration:none;z-index:4;"
};
export var childrenLink = /*#__PURE__*/css(applyFont(typography.mini), ";color:", colors.neutral.heavy.default, ";text-decoration:none;z-index:4;display:flex;flex-direction:row;align-items:center;padding:", spacing.m, ";[data-new-dev-layout='three-column'] &{padding-left:0;padding-top:", spacing.xs, ";}");
export var childrenLinkArrow = {
  name: "19rsff",
  styles: "width:18px;height:18px;"
};
export var imageInfo = {
  name: "79elbk",
  styles: "position:relative;"
};
export var pills = {
  name: "r8060f",
  styles: "display:flex;flex-direction:row;align-items:flex-end;flex-grow:1;z-index:4;"
};